import { render, staticRenderFns } from "./PrijavaDetails.vue?vue&type=template&id=1b2354f9&scoped=true&"
import script from "./PrijavaDetails.vue?vue&type=script&lang=js&"
export * from "./PrijavaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2354f9",
  null
  
)

export default component.exports